<template>
  <v-btn-toggle v-model="localValue" flat :class="fieldClass" v-if="useButtons">
    <v-btn v-for="(l, idx) in languages" :key="`lang-select-${idx}`" :value="l.text" text>
      {{ l.display }}
    </v-btn>
  </v-btn-toggle>
  <v-select
    v-else
    v-model.trim="localValue"
    :items="languages"
    item-text="display"
    item-value="text"
    :label="$t('labels.language')"
    :error-messages="errors"
    :class="fieldClass"
    :prepend-icon="prependIcon"
    :append-icon="appendIcon"
  />
</template>

<script>
import { CustomFieldMixin } from '../mixins'

export default {
  name: 'LanguageField',
  mixins: [CustomFieldMixin],
  props: {
    useButtons: { type: Boolean, default: false },
    immediate: { type: Boolean, default: false },
    prependIcon: String,
    //TODO: https://github.com/vuetifyjs/vuetify/issues/4447
    appendIcon: String
  },
  data: () => ({
    languages: [
      { display: 'English', text: 'en' },
      { display: 'Français', text: 'fr' }
    ]
  }),
  computed: {
    localValue: {
      get() {
        return this.value
      },
      set(v) {
        this.setValue(v)
        if (this.immediate) {
          this.$root.$i18n.locale = v
        }
      }
    }
  }
}
</script>
